module.exports = __webpack_public_path__ + "img/red_071.29f8684a.png";